module.exports = __webpack_public_path__ + "img/remix_logo_orange.4b69d056.svg";